import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

export const useQueryParam = (key) => {
  const { search } = useLocation();
  return useMemo(() => {
    const value = new URLSearchParams(search).get(key);
    if (value == null) return null;
    // In query strings '+' decodes as space; ShareLink IDs are base64 and use '+'.
    if (key === 'id') {
      return value.replace(/ /g, '+').trim();
    }
    return value;
  }, [search, key]);
};
